import moment from 'moment';
import ApiBase from '../ApiBase';

/**
 * @classdesc API for setting attendance
 */
export default new class extends ApiBase {
    /**
     * @method create
     * @param {object} data
     * @return {Promise<*>}
     */
    create = (data) => this.post('attendance', data, 'create', [200, 201]);

    /**
     * @method here
     * @param {Date} date
     * @param {object} data
     * @param {string} userId
     * @return {Promise<*>}
     */
    checkIn = (date, data, userId = null) => this.create({
        ...data,
        user_id: userId,
        date: date ?? moment().format('YYYY-MM-DD'),
        check_in: moment().format('HH:mm:ss'),
        check_out: null,
    });

    /**
     * @method update
     * @param {string} id
     * @param {object} data
     * @return {Promise<boolean|{status: number}>}
     */
    update = (id, data) => this.patch(
        `attendance/${id}`,
        data,
        'update'
    );

    /**
     * @method checkOut
     * @param {string} id
     * @return {Promise<boolean|{status: number}>}
     */
    checkOut = (id) => this.update(id, {
        check_out: moment().format('HH:mm:ss'),
    });

    /**
     * @method get
     * @param {string} id
     * @return {*}
     */
    fetch = (id) => this.get(`attendance/${id}`);
};
